import React, {useContext} from "react";
import {Button, Typography} from "@bezlimit/bezlimit-ui";
import {ModalContext} from "../../../core/Contexts";
import useLockBodyScroll from "../../../core/hooks/useLockBodyScroll";
import SwipeToClose from "../../blocks/ui/swipeToClose";
import "./result.scss";
import successImg from "../../../images/success.png";
import errorEmoji from "../../../images/esim_error_emoji.png";

const useClose = () => {
    const contextModal = useContext(ModalContext);
    return () => {
        contextModal?.setVisible(false);
        contextModal?.setCssClass("");
    };
};

export const AttachEsimSuccess = React.memo(function AttachEsimSuccess() {
    const onClose = useClose();
    useLockBodyScroll();
    return (
        <SwipeToClose onClose={onClose}>
            <Typography
                as="div"
                className="bl-attach-esim-result bl-attach-esim-result--success"
            >
                <div className="bl-attach-esim-result__card">
                <img src={successImg} alt="" className="bl-attach-esim-result__icon" />
                <div className="bl-attach-esim-result__title">
                    eSIM успешно{" "}
                    <br className="esim-br" />
                    оформлена!{" "}
                    <span aria-hidden role="img">
                        🎉
                    </span>
                </div>
                <div className="bl-attach-esim-result__text">
                    На ранее указанный Вами email{" "}
                    <br className="esim-br" />
                    в течение 30 минут будет отправлена{" "}
                    <br className="esim-br" />
                    инструкция по установке eSIM.{" "}
                    <br className="esim-br" />
                    Пожалуйста, воспользуйтесь{" "}
                    <br className="esim-br" />
                    инструкцией
                </div>
            </div>
                <Button
                    type="primary"
                    className="bl-attach-esim-result__close-btn"
                    onClick={onClose}
                >
                    Закрыть
                </Button>
            </Typography>
        </SwipeToClose>
    );
});

export const AttachEsimError = React.memo(function AttachEsimError() {
    const onClose = useClose();
    useLockBodyScroll();
    return (
        <SwipeToClose onClose={onClose}>
            <Typography as="div" className="bl-attach-esim-result bl-attach-esim-result--error">
                <div className="bl-attach-esim-result__card">
                    <div className="bl-attach-esim-result__error-icon-wrap">
                        <span className="bl-attach-esim-result__error-circle" aria-hidden />
                        <img
                            src={errorEmoji}
                            alt=""
                            className="bl-attach-esim-result__icon bl-attach-esim-result__error-emoji"
                        />
                    </div>
                    <div className="bl-attach-esim-result__title">
                        Хм... что-то пошло не так
                    </div>
                </div>
                <Button
                    type="primary"
                    className="bl-attach-esim-result__close-btn"
                    onClick={onClose}
                >
                    Закрыть
                </Button>
            </Typography>
        </SwipeToClose>
    );
});
